<template>
  <!-- 主容器 -->
  <div class="app-container">
    <!-- 搜索区域 -->
    <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="80px">
      <!-- 班级名称搜索 -->
      <el-form-item label="班级名称" prop="className">
        <el-input v-model="queryParams.className" placeholder="请输入班级名称" clearable size="small"
          @keyup.enter.native="handleQuery" />
      </el-form-item>

      <!-- 专业选择搜索 -->
      <!-- 对话框表单修改后示例 -->
      <el-form-item label="所属专业" prop="majorName">
        <el-input v-model="form.majorName" placeholder="请输入专业名称" clearable size="small"
          @keyup.enter.native="handleQuery" />
      </el-form-item>

      <!-- 班主任搜索 -->
      <el-form-item label="班主任" prop="teacherName">
        <el-input v-model="queryParams.teacherName" placeholder="请输入班主任姓名" clearable size="small"
          @keyup.enter.native="handleQuery" />
      </el-form-item>


      <!-- 搜索按钮 -->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">
          搜索
        </el-button>
        <el-button icon="el-icon-refresh" size="small" @click="resetQuery">
          重置
        </el-button>
      </el-form-item>
    </el-form>

    <!-- 操作按钮区域 -->
    <el-row :gutter="10" class="mb8">
      <!-- 新增按钮 -->
      <el-col :span="1.5">
        <el-button type="primary" plain icon="el-icon-plus" size="small" @click="handleAdd">
          新增
        </el-button>
      </el-col>

      <el-col :span="1.5">
        <el-button type="success" plain icon="el-icon-edit" size="mini" :disabled="single"
          @click="handleUpdate">修改</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="danger" plain icon="el-icon-delete" size="mini" :disabled="multiple"
          @click="handleDelete">删除</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="warning" plain icon="el-icon-download" size="mini" @click="handleExport">导出</el-button>
      </el-col>

    </el-row>

    <!-- 数据表格 -->
    <el-table v-loading="loading" :data="classesList" @selection-change="handleSelectionChange" class="table-container">
      <!-- 选择列 -->
      <el-table-column type="selection" width="55" align="center" />

      <!-- 班级ID列 -->
      <el-table-column label="班级ID" align="center" prop="id" width="80" />

      <!-- 班级名称列 -->
      <el-table-column label="班级名称" align="center" prop="className" />

      <!-- 所属专业列 -->
      <el-table-column label="所属专业" align="center" prop="majorName" />

      <!-- 班主任列 -->
      <el-table-column label="班主任" align="center" prop="teacherName" />

      <!-- 学生人数列 -->
      <el-table-column label="学生人数" align="center" prop="studentCount" width="100" />

      <!-- 起止日期列（合并显示） -->
      <el-table-column label="起止日期" align="center" width="220">
        <template slot-scope="scope">
          {{ scope.row.startDate }} 至 {{ scope.row.endDate }}
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="180">
        <template slot-scope="scope">
          <!-- 修改按钮 -->
          <el-button size="mini" type="text" icon="el-icon-edit" @click="handleUpdate(scope.row)">
            修改
          </el-button>

          <!-- 删除按钮 -->
          <el-button size="mini" type="text" icon="el-icon-delete" @click="handleDelete(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <el-pagination background class="pagination-container" v-show="total > 0" :current-page="queryParams.pageNum"
      :page-sizes="[5, 10, 20, 50]" :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper"
      :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <!-- 班级名称输入 -->
        <el-form-item label="班级名称" prop="className">
          <el-input v-model="form.className" placeholder="请输入班级名称" />
        </el-form-item>

        <!-- 专业选择 -->
        <el-form-item label="所属专业" prop="majorId">
          <el-select v-model="form.majorName" placeholder="请选择专业">
            <el-option v-for="major in majorOptions" :key="major.majorId" :label="major.majorName"
              :value="major.majorId" />
          </el-select>
        </el-form-item>

        <!-- 班主任输入 -->
        <el-form-item label="班主任" prop="teacherName">
          <el-select v-model="form.teacherName" placeholder="请选择班主任">
            <el-option v-for="teacher in teacherOptions" :key="teacher.id" :label="teacher.teacherName"
              :value="teacher.teacherName" />
          </el-select>
        </el-form-item>

        <!-- 学生人数输入 -->
        <el-form-item label="学生人数" prop="studentCount">
          <el-input-number v-model="form.studentCount" controls-position="right" style="width: 30%" />
        </el-form-item>

        <!-- 开始日期选择 -->
        <el-form-item label="开始日期" prop="startDate">
          <el-date-picker v-model="form.startDate" type="date" value-format="yyyy-MM-dd" placeholder="选择开始日期"
            style="width: 100%" />
        </el-form-item>

        <!-- 结束日期选择 -->
        <el-form-item label="结束日期" prop="endDate">
          <el-date-picker v-model="form.endDate" type="date" value-format="yyyy-MM-dd" placeholder="选择结束日期"
            style="width: 100%" />
        </el-form-item>
      </el-form>

      <!-- 对话框底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 导入API方法
import { listClasses, getClasses, delClasses, addClasses, updateClasses } from "@/api/OmdClasses/classes";
import { listMajors } from "@/api/OmdMajors/majors";
import { listTeachers } from "@/api/OmdTeachers/teachers";
import { download } from "@/utils/request";

export default {
  name: "ClassMain",
  data() {
    return {
      // 加载状态
      loading: true,
      // 选中行的ID数组
      ids: [],
      // 是否单选（用于判断修改按钮状态）
      single: true,
      // 是否多选（用于判断删除按钮状态）
      multiple: true,
      // 是否显示搜索区域
      showSearch: true,
      // 总条数
      total: 0,
      // 班级列表数据
      classesList: [],
      // 专业选项数据
      majorOptions: [],
      teacherOptions: [], // 教师选项列表
      // 对话框标题
      title: "",
      // 是否显示对话框
      open: false,
      // 日期范围（用于搜索）
      dateRange: [],

      // 查询参数
      queryParams: {
        pageNum: 1,       // 当前页码
        pageSize: 10,     // 每页条数
        className: null,  // 班级名称
        majorId: null,    // 专业ID
        teacherName: null,// 班主任姓名
        studentCount: null, // 学生人数
        startDate: null,  // 开始日期
        endDate: null     // 结束日期
      },

      // 表单数据
      form: {
        id: null,         // 班级ID
        className: null,  // 班级名称
        majorId: null,    // 专业ID
        teacherName: null,// 班主任姓名
        studentCount: null, // 学生人数
        startDate: null,  // 开始日期
        endDate: null     // 结束日期
      },

      // 表单验证规则
      rules: {
        className: [
          { required: true, message: "班级名称不能为空", trigger: "blur" }
        ],
        majorId: [
          { required: true, message: "所属专业不能为空", trigger: "change" }
        ],
        teacherName: [
          { required: true, max: 50, message: "长度不能超过50个字符", trigger: "blur" }
        ],
        studentCount: [
          { type: 'number', message: '必须为数字值', trigger: 'blur' },
        ],
        startDate: [
          { required: true, message: "开始日期不能为空", trigger: "change" }
        ],
        endDate: [
          { required: true, message: "结束日期不能为空", trigger: "change" },
          // 自定义验证：结束日期不能早于开始日期
          {
            validator: (rule, value, callback) => {
              if (this.form.startDate && value < this.form.startDate) {
                callback(new Error("结束日期不能早于开始日期"));
              } else {
                callback();
              }
            },
            trigger: "change"
          }
        ]
      }
    };
  },
  created() {
    // 组件创建时获取数据
    this.getList();
    this.getMajorList();
    this.getTeachers();

  },
  methods: {
    /**
     * 获取班级列表
     * @return {void}
     */
    getList() {
      this.loading = true;
      listClasses(this.queryParams)
        .then(response => {
          // 处理响应数据，确保字段名与表格列prop对应
          this.classesList = response.rows;
          this.total = response.total;
          this.loading = false;
          console.log(response);
        })
        .catch(() => {
          this.loading = false;
        });
    },

    /**
     * 获取专业列表
     * @return {void}
     */
    getMajorList() {
      listMajors()
        .then(response => {
          this.majorOptions = response.rows;
        })
        .catch(error => {
          console.error("获取专业列表失败:", error);
        });
    },

    /**
     * 获取教师列表
     * @return {void}
     */
    getTeachers() {
      listTeachers().then(response => {
        this.teacherOptions = response.rows || response.data
      })
    },

    /**
     * 处理日期范围变化事件
     * @param {Array} val 日期范围数组 [startDate, endDate]
     * @return {void}
     */
    handleDateChange(val) {
      this.queryParams.startDate = val ? val[0] : null;
      this.queryParams.endDate = val ? val[1] : null;
    },

    /**
     * 每页条数变化事件
     * @param {number} val 新的每页条数
     * @return {void}
     */
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },

    /**
     * 当前页变化事件
     * @param {number} val 新的页码
     * @return {void}
     */
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },

    /**
     * 取消操作（关闭对话框）
     * @return {void}
     */
    cancel() {
      this.open = false;
      this.reset();
    },

    /**
     * 重置表单
     * @return {void}
     */
    reset() {
      this.form = {
        id: null,
        className: null,
        majorId: null,
        teacherName: null,
        studentCount: null,
        startDate: null,
        endDate: null
      };
      // 重置表单验证状态
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }

    },

    /**
     * 搜索操作
     * @return {void}
     */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },

    /**
     * 重置搜索表单
     * @return {void}
     */
    resetQuery() {
      this.dateRange = [];
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        className: null,
        majorId: null,
        teacherName: null,
        studentCount: null,
        startDate: null,
        endDate: null
      };
      this.handleQuery();
    },

    /**
     * 表格选择项变化事件
     * @param {Array} selection 选中的行数据
     * @return {void}
     */
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },

    /**
     * 新增操作
     * @return {void}
     */
    handleAdd() {

      this.reset();
      this.open = true;
      this.title = "添加班级";
    },

    /**
     * 修改操作
     * @param {Object} row 行数据
     * @return {void}
     */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids[0];
      getClasses(id)
        .then(response => {
          // 转换后端字段名为前端命名
          this.form = response.data;
          this.open = true;
          this.title = "修改班级";
        })
        .catch(error => {
          console.error("获取班级详情失败:", error);
        });
    },

    /**
     * 提交表单
     * @return {void}
     */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          // 转换前端字段名为后端命名
          const postData = {
            ...this.form
          };

          // 根据是否有ID判断是新增还是修改
          const operation = this.form.id ? updateClasses(postData) : addClasses(postData);

          operation.then(response => {
            this.$modal.msgSuccess(this.form.id ? "修改成功" : "新增成功");
            this.open = false;
            this.getList();
            console.log(response);
          })
            .catch(error => {
              console.error("操作失败:", error);
            });
        }
      });
    },

    /**
     * 删除操作
     * @param {Object|Number} row 行数据或ID
     * @return {void}
     */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$confirm(`是否确认删除编号为"${ids}"的班级？`, '警告', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning',
        confirmButtonClass: 'confirm-danger-button',
        cancelButtonClass: 'cancel-button'
      })
        .then(() => delClasses(ids))
        .then(() => {
          this.getList();
          this.$message.success('删除成功');
        })
        .catch(() => { });

    },
      /** 导出按钮操作 */
    handleExport() {

      download('/OmdClasses/classes/export', {
        ...this.queryParams
      }, `班级表_${new Date().getTime()}.xlsx`)
    }
  }
}

</script>


<style scoped>
/* 主容器样式 */
.app-container {
  padding: 20px;
}


/* 表格操作按钮紧凑样式 */
.small-padding .el-button {
  padding: 5px;
  margin-left: 0;
}

/* 表格头部*/
::v-deep .el-table__header-wrapper .el-table__header th {
  background-color: #f4f4f4 !important;
  ;
  /* 表格头部背景颜色 */
  color: #000 !important;
}

/* 分页器样式 */
::v-deep .el-pager li.active {
  background-color: var(--primary-color) !important;
  color: white !important;
  border-color: var(--primary-color) !important;
  font-weight: bold;
  cursor: pointer;
}

/* 分页器样式 */
::v-deep .el-pager li.active:hover {
  background-color: #d6336c !important;
  color: white !important;
  background-color: #d6336c !important;
  font-weight: bold;
  cursor: pointer;
}

/*按钮的样式 主要按钮 的样式*/

::v-deep .el-button--primary {
  color: #fff;
  background-color: var(--primary-color);
  border: 1px solid var(--primary-color);
}

/*鼠标获得焦点的样式*/
::v-deep .el-button--primary:hover {
  background-color: #d6336c !important;
  ;
}

/* 在全局样式文件中添加 */
::v-deep .el-button:focus {
  outline: none !important;
  box-shadow: none !important;
}

/* 如果按钮是 plain 样式 */
::v-deep.el-button--plain:focus {
  outline: none !important;
  box-shadow: none !important;
}

/* 表格中的文字 */
/* ::v-deep .el-button--text  {
  color: var(--primary-color);
}   */


::v-deep .el-button--primary:focus,
.el-button--primary:hover {
  background-color: var(--primary-color);
  border: none;
  color: #fff;
}

/* 文本框 初始边框
::v-deep .el-input__inner,.el-textarea__inner {
  border:1px solid var(--primary-color);
} */
/* 文本框鼠标获得焦点边框 */
::v-deep .el-input__inner:focus {
  border-color: var(--primary-color) !important;
}

/* 如果是 textarea */
::v-deep .el-textarea__inner:focus {
  border-color: var(--primary-color) !important;
}

/* 在全局样式或组件样式中添加 */
::v-deep.confirm-delete-button {
  background-color: #f56c6c !important;
  border-color: #f56c6c !important;
}

::v-deep.confirm-delete-button:hover {
  background-color: #e05c5c !important;
  border-color: #e05c5c !important;
}
</style>